import { CategoryLensTypes } from "constants/dataTypes";


export const getMinPriceLensItem = (categoryLensTypes: CategoryLensTypes[]) => {
  if (categoryLensTypes) {
    //categoryLensTypes find cheapest lens type 
    const cheapestLensType = categoryLensTypes.reduce((min: CategoryLensTypes, current: CategoryLensTypes) => {
      return current.price < min.price ? current : min;
    });
    return cheapestLensType;
  }
}
export const getMinPriceForLensType = (categoryLensTypes: CategoryLensTypes[], lensTypeIncludes: string) => {
  if (!categoryLensTypes || categoryLensTypes.length === 0) {
    return null;
  }

  const matchingLensTypes = categoryLensTypes.filter(lensType => 
    lensType.type.toLowerCase().includes(lensTypeIncludes.toLowerCase())
  );

  if (matchingLensTypes.length === 0) {
    return null;
  }

  return matchingLensTypes.reduce((min, current) => 
    current.price < min.price ? current : min
  );
};
export function filterLensTypes(glassesProductData: any): CategoryLensTypes[] {
    const categoryLensTypes: CategoryLensTypes[] = [];
    let cheapestLensType: CategoryLensTypes | null = null;
    let cheapestMirrorLensType: CategoryLensTypes | null = null;
    let maxRegularPrice = 0;
    let maxMirrorPrice = 0;
    let maxRegularRegularPrice = 0;
    let maxMirrorRegularPrice = 0;

    // Iterate through all Lens.products
    glassesProductData.Lens.products.forEach((product: any) => {
        product.lens_types.forEach((lens_type: any) => {
            const isMirror = lens_type.type.toLowerCase().includes('mirror');

            // Update max prices based on lens type
            if (isMirror) {
                maxMirrorPrice = Math.max(maxMirrorPrice, lens_type.price);
                maxMirrorRegularPrice = Math.max(maxMirrorRegularPrice, lens_type.regular_price);
            } else {
                maxRegularPrice = Math.max(maxRegularPrice, lens_type.price);
                maxRegularRegularPrice = Math.max(maxRegularRegularPrice, lens_type.regular_price);
            }

            // Check for cheapest overall lens type
            if (!cheapestLensType || lens_type.price < cheapestLensType.price) {
                cheapestLensType = lens_type;
            }

            // Check for cheapest mirror lens type
            if (isMirror && (!cheapestMirrorLensType || lens_type.price < cheapestMirrorLensType.price)) {
                cheapestMirrorLensType = lens_type;
            }
        });
    });

    // Add cheapest overall lens type
    if (cheapestLensType) {
        categoryLensTypes.push({
            ...(cheapestLensType as CategoryLensTypes),
            price_max: maxRegularPrice,
            regular_price_max: maxRegularRegularPrice
        });
    }

    // Add cheapest mirror lens type if it exists and is different from the cheapest overall
    if (cheapestMirrorLensType && cheapestMirrorLensType !== cheapestLensType) {
        categoryLensTypes.push({
            ...(cheapestMirrorLensType as CategoryLensTypes),
            price_max: maxMirrorPrice,
            regular_price_max: maxMirrorRegularPrice
        });
    }

    return categoryLensTypes;
}
